import React, { useState } from "react";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Snackbar from "@material-ui/core/Snackbar";
import { Alert } from "@material-ui/lab";
import { useParams } from "react-router-dom";
import { deleteEmployee, deleteUser } from "../../../action/account";

export default function DeleteAccount() {
  const params = useParams();
  const partnerId = params.partnerId ?? 0;

  const [email, setEmail] = useState("");
  const [formValid, setFormValid] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");

  const [openAlert, setOpenAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("success");

  function validateEmail(e) {
    let re = /^\S+@\S+\.\S+$/;
    return re.test(String(e).toLowerCase());
  }

  function handleSubmit(e) {
    if (e && e.preventDefault) e.preventDefault();
    if (validateEmail(email)) {
      if (partnerId === 0 || partnerId === "0") {
        deleteUser(email).then((response) => {
          setOpenAlert(true);
          setAlertSeverity(response && response.success === 1 ? "success" : "error");
          setAlertMessage(response ? response.msg : "Permintaan gagal dikirim.");
        });
      } else {
        deleteEmployee(email, partnerId).then((response) => {
          setOpenAlert(true);
          setAlertSeverity(response && response.success === 1 ? "success" : "error");
          setAlertMessage(response ? response.msg : "Permintaan gagal dikirim.");
        });
      }
    } else {
      setFormValid(false);
      setErrorMessage("Format email tidak valid");
    }
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#F8FAFC",
        paddingTop: "120px",
        paddingBottom: "80px",
      }}
    >
      <Snackbar
        open={openAlert}
        autoHideDuration={5000}
        onClose={() => setOpenAlert(false)}
      >
        <Alert severity={alertSeverity}>{alertMessage}</Alert>
      </Snackbar>

      <Container maxWidth="sm">
        <div
          style={{
            backgroundColor: "#ffffff",
            borderRadius: "24px",
            padding: "40px 32px",
            border: "1px solid #E2E8F0",
            boxShadow: "0 15px 35px -5px rgba(0, 0, 0, 0.05)",
            textAlign: "center",
          }}
        >
          <div
            style={{
              width: "56px",
              height: "56px",
              borderRadius: "50%",
              backgroundColor: "rgba(239, 68, 68, 0.1)",
              color: "#ef4444",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "24px",
              margin: "0 auto 16px auto",
            }}
          >
            ⚠️
          </div>

          <Typography
            variant="h4"
            style={{
              fontWeight: 800,
              fontSize: "24px",
              color: "#0F172A",
              marginBottom: "8px",
            }}
          >
            Permohonan Penghapusan Akun
          </Typography>

          <p
            style={{
              color: "#64748B",
              fontSize: "14px",
              lineHeight: 1.6,
              marginBottom: "28px",
            }}
          >
            Masukkan alamat email yang terdaftar pada akun UR Anda. Tautan konfirmasi penghapusan akun akan dikirimkan ke email tersebut.
          </p>

          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: "24px", textAlign: "left" }}>
              <TextField
                required
                fullWidth
                variant="outlined"
                type="email"
                label="Alamat Email Terdaftar"
                value={email}
                error={!formValid}
                helperText={errorMessage}
                onChange={(e) => {
                  setFormValid(true);
                  setErrorMessage("");
                  setEmail(e.target.value);
                }}
              />
            </div>

            <Button
              fullWidth
              variant="contained"
              type="submit"
              style={{
                backgroundColor: "#ef4444",
                color: "#ffffff",
                fontWeight: 700,
                fontSize: "15px",
                padding: "12px",
                borderRadius: "9999px",
                textTransform: "none",
                boxShadow: "0 4px 15px rgba(239, 68, 68, 0.35)",
              }}
            >
              Kirim Permohonan Hapus Akun
            </Button>
          </form>
        </div>
      </Container>
    </div>
  );
}